import type {
  CreateTemplateAPIResponse,
  CreateTemplateRequestBody,
  DeleteTemplateAPIResponse,
  DeleteTemplateRequestBody,
  GetTemplatesRequestBody,
  UpdateTemplateAPIResponse,
  UpdateTemplateRequestBody,
  Template,
  GetTemplateByIdRequestBody,
} from "@/common/types/templates";
import axiosClient from "@/lib/axios/axiosClient";

export const getCustomTemplates = async (
  doctorTemplateBody: GetTemplatesRequestBody
): Promise<Template[]> => {
  const response = await axiosClient.post<Template[]>(
    "/get-doctor-template",
    doctorTemplateBody,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};

export const getCustomTemplateById = async (
  getDoctorTemplateByIdBody: GetTemplateByIdRequestBody
): Promise<Template> => {
  const response = await axiosClient.post<Template>(
    "/get-doctor-template-by-id",
    getDoctorTemplateByIdBody,
    {
      sendToken: true,
      headers: {
        Accept: "application/json",
        "Content-Type": "text/plain; charset=utf-8",
      },
    }
  );

  return response.data;
};

export const createTemplate = async (
  body: CreateTemplateRequestBody
): Promise<CreateTemplateAPIResponse> => {
  const response = await axiosClient.post<CreateTemplateAPIResponse>(
    "/add-doctor-template",
    body,
    {
      sendToken: true,
    }
  );

  return response.data;
};

export const updateTemplate = async (
  body: UpdateTemplateRequestBody
): Promise<UpdateTemplateAPIResponse> => {
  const response = await axiosClient.post<UpdateTemplateAPIResponse>(
    "/update-doctor-template",
    body,
    {
      sendToken: true,
    }
  );

  return response.data;
};

export const deleteTemplate = async (
  body: DeleteTemplateRequestBody
): Promise<DeleteTemplateAPIResponse> => {
  const response = await axiosClient.post<DeleteTemplateAPIResponse>(
    "/delete-doctor-template",
    body,
    {
      sendToken: true,
    }
  );

  return response.data;
};
